import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { CustomSelectField, CustomTextField } from '../../components';

const hasItems = (arr) => Array.isArray(arr) && arr.length > 0;

// TODO: RENAME COMPONENT TO DESCRIBE SERVICE TYPE SELECTION
function AssistanceRequestForm({
  serviceTypes,
  language,
  allowedServiceTypeIds = null,
  serviceTypeIdsToRemove = null,
}) {
  let serviceTypesOptions = _.filter(
    serviceTypes,
    (s) => s && _.isEmpty(s.relationships),
  ).map((serviceType) => ({
    display_name: serviceType.attributes.name,
    value: serviceType.id,
  }));

  if (hasItems(allowedServiceTypeIds) && hasItems(serviceTypeIdsToRemove)) {
    console.error(
      "Unexpected behavior might occur if both allowedServiceTypeIds and serviceTypeIdsToRemove are set",
    );
  }

  // Removes all service types not included in allowedServiceTypeIds
  if (allowedServiceTypeIds) {
    serviceTypesOptions = _.filter(
      serviceTypesOptions,
      (s) => s && allowedServiceTypeIds.includes(s.value),
    );
  }

  // Removes all service types included in serviceTypeIdsToRemove
  if (serviceTypeIdsToRemove) {
    serviceTypesOptions = _.filter(
      serviceTypesOptions,
      (s) => s && !serviceTypeIdsToRemove.includes(s.value),
    );
  }

  return (
    <div>
      <CustomSelectField
        name="service_types"
        id="uu_service_types"
        label={(
          <FormattedMessage
            id="9pSUzk"
            description="servicesSeeking"
            defaultMessage="What services are you seeking?"
          />
        )}
        options={serviceTypesOptions}
        required
        language={language}
      />
      <CustomTextField
        name="description"
        id="uu_description"
        label={(
          <FormattedMessage
            id="ypc766"
            description="describeRequest"
            defaultMessage="Please describe your request for services"
          />
        )}
        required
        language={language}
      />
    </div>
  );
}

AssistanceRequestForm.propTypes = {
  serviceTypes: PropTypes.array.isRequired,
  language: PropTypes.string.isRequired,
  allowedServiceTypeIds: PropTypes.arrayOf(PropTypes.string),
  serviceTypeIdsToRemove: PropTypes.arrayOf(PropTypes.string),
};

AssistanceRequestForm.defaultProps = {
  allowedServiceTypeIds: null,
  serviceTypeIdsToRemove: null,
};

export default AssistanceRequestForm;
